module.exports = __webpack_public_path__ + "img/brick-vertical.df8a00b6.svg";